import React, { useEffect, useRef } from 'react';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import axios from 'axios';
import { setTokensFromResponse } from '../../utils/authTokens';
import { fetchAndSetOrganization, getOrgIdFromUser } from '../../utils/organizationService';
import validator from "validator";
import { jwtDecode } from "jwt-decode";
import posthog from 'posthog-js';

const GoogleSignInButton = ({page,user,setErrormsg, setStep, step, loader, setLoader, navigate, setUser, redirectTo}) => {
  const awaitingGoogleResponse = useRef(false);

  useEffect(() => {
    const handleWindowFocus = () => {
      // Popup closed without completing sign-in does not call onError; reset on return.
      setTimeout(() => {
        if (awaitingGoogleResponse.current) {
          awaitingGoogleResponse.current = false;
          setLoader(false);
        }
      }, 500);
    };

    window.addEventListener('focus', handleWindowFocus);
    return () => window.removeEventListener('focus', handleWindowFocus);
  }, [setLoader]);

  const handleLoginSuccess = async(response) => {
    awaitingGoogleResponse.current = false;
    setErrormsg(null)
    setLoader(true);
   
    var user_object = jwtDecode(response.credential);
    if(page === 'register'){
        //google
          
           
        
              try {
                await axios
                  .post(process.env.REACT_APP_BACKEND_URL + "user/create-just-user", {
                    google_id_token: response.credential,
                    company_name: user.company_name,
                    email: user_object.email,
                    first_name: user_object.given_name,
                    last_name: user_object.family_name,
                    registered_from_google: true,
                  })
                  .then((res) => {
                    if (res.data.status === "success") {
                      localStorage.setItem("user", JSON.stringify(res.data.user)); //store user data in local storage
                      if (res.data.access_token) {
                        setTokensFromResponse(res.data);
                      }
                      // localStorage.setItem(
                      //   "organization",
                      //   JSON.stringify(res.data.organization)
                      // ); 
                      // setStep(step + 1);
                      setLoader(false);
                      setUser({...user,registeredFromGoogle: true,
                        email: user_object.email,
                    password: user_object.email,
                    first_name: user_object.given_name,
                    last_name: user_object.family_name,
                    userId: res.data.user.userId.S,
                   //  agreed: false
                      })
                      document.getElementById("123").focus();
                    } else {
                      setErrormsg(res.data.msg);
                      setLoader(false);
                    }
                  })
                  .catch((err) => {
                    setLoader(false);
                  });
              } catch (error) {
                // Log for production diagnostics when create-just-user fails
                console.error("SigninWithGoogle: create-just-user failed", error.response?.data || error.message || error);
                if (error.response && error.response.data) {
                  setErrormsg(error.response.data.message);
                }
                setLoader(false);
              }
        
    }else{
            setErrormsg(null);
            try {
                let user_data = await axios.post(
                  process.env.REACT_APP_BACKEND_URL + "get-user",
                  {
                    google_id_token: response.credential,
                    email: user_object.email,
                    login_from_google: true,
                  }
                )
                localStorage.setItem('user', JSON.stringify(user_data.data.user));
                if (user_data.data.access_token) {
                  setTokensFromResponse(user_data.data);
                }
        
              const org_id = getOrgIdFromUser(user_data.data.user);

             if (redirectTo && redirectTo.startsWith("/") && !redirectTo.startsWith("//")) {
              if (org_id) {
                await fetchAndSetOrganization(org_id);
              }
              navigate(redirectTo);
             } else if (org_id) {
              await fetchAndSetOrganization(org_id);
              navigate("/dashboard/");
             } else {
              console.info("[Auth] Redirecting to create-organization: Google sign-in succeeded but user has no organizations.");
              navigate('/create-organization')
             }
        
              setLoader(false);
            } catch (error) {
              // Log for production diagnostics when get-user (Google) fails
              console.error("SigninWithGoogle: get-user failed", error.response?.data || error.message || error);
              if (error.response && error.response.data) {
                setErrormsg(error.response.data.message)
              }
              setLoader(false)
            }
    }
  };

  const handleLoginFailure = (error) => {
    awaitingGoogleResponse.current = false;
    // Log for production diagnostics when Google OAuth fails
    console.error('Google Login Failure:', error);
    setErrormsg('Google Login Failure:'+error)
    setLoader(false);
  };

  const handleGoogleClick = () => {
    awaitingGoogleResponse.current = true;
  };

  return (
    <div className="ta-google-signin-wrap relative w-full" style={{ minHeight: 40 }}>
      {/* Visible custom styling – behind the clickable area */}
      <div
        className="ta-google-signin-label w-full flex justify-center items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white pointer-events-none whitespace-nowrap"
        aria-hidden="true"
      >
        <svg className="w-5 h-5 mr-2" viewBox="0 0 24 24">
          <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
          <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
          <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
          <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
        </svg>
        {loader
          ? 'Signing in...'
          : page === 'login'
            ? 'Login with Google'
            : 'Continue with Google'}
      </div>
      {/* Google button overlaid – receives the real click so the popup isn't blocked */}
      <div
        className="absolute inset-0 flex items-center justify-center"
        style={{ opacity: 0, cursor: loader ? 'wait' : 'pointer' }}
        aria-label="Sign in with Google"
      >
        <GoogleLogin
          onSuccess={handleLoginSuccess}
          onError={handleLoginFailure}
          click_listener={handleGoogleClick}
          useOneTap={false}
        />
      </div>
    </div>
  );
};

const SigninWithGoogle = (props) => {
  return (
    <GoogleOAuthProvider clientId="910554755020-8dlg999mposgad3p96e1ktpufbu3ia7n.apps.googleusercontent.com">
      <GoogleSignInButton {...props} />
    </GoogleOAuthProvider>
  );
};

export default SigninWithGoogle;
